<template>
  <header class="glass-header">
    <div class="layout-container header-inner">
      <div class="logo-div">
        <a href="/" class="logo-link">
          <img src="../assets/logo.jpg" alt="NovareAI Logo" class="logo">
          <div class="logo-stack">
            <span class="logo-text">NovareAI</span>
            <span class="logo-subtext">AI enabled assistants</span>
          </div>
        </a>
      </div>
      <div class="nav-container">
        <nav class="nav-links">
          <a href="/#features" class="ghost-link">Features</a>
          <a href="/#pricing" class="ghost-link">Pricing</a>
          <router-link to="/register" class="pill-button primary">Get Started</router-link>
        </nav>
        <button class="icon-button menu-icon" @click="toggleMenu" aria-label="Toggle menu">
          <span class="hamburger">☰</span>
        </button>
        <div v-if="menuOpen" class="dropdown-menu glass-strong">
          <ul>
            <li><router-link to="/" replace @click="closeMenu" class="ghost-link">Home</router-link></li>
            <li v-if="!isAuthenticated"><router-link to="/register" @click="closeMenu"
                class="ghost-link">Register</router-link></li>
            <li v-if="!isAuthenticated"><router-link to="/login" @click="closeMenu"
                class="ghost-link">Login</router-link></li>
            <li v-if="isAuthenticated"><router-link to="/admin" @click="closeMenu"
                class="ghost-link">Admin</router-link></li>
            <li v-if="isAuthenticated"><a href="#" @click="logout" class="ghost-link">Logout</a></li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import auth from '@/services/auth'; // Importing the auth module

export default {
  name: "SiteHeader",
  data() {
    return {
      menuOpen: false // Track the state of the hamburger menu
    };
  },
  computed: {
    isAuthenticated() {
      return auth.checkAuth(); // Compute authentication status dynamically
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen; // Toggle the hamburger menu
    },
    closeMenu() {
      this.menuOpen = false; // Close the hamburger menu when a link is clicked
    },
    logout(event) {
      event.preventDefault();
      auth.logout(); // Call auth's logout function
      localStorage.removeItem("chatbotRecords");
      localStorage.removeItem("customerRecord");
      localStorage.removeItem("userId");
      this.$router.push("/"); // Redirect to the Home page after logout
      this.menuOpen = false; // Close the menu after logout
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector(".dropdown-menu");
      const menuIcon = this.$el.querySelector(".menu-icon");
      if (dropdown && !dropdown.contains(event.target) && !menuIcon.contains(event.target)) {
        this.menuOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  gap: 12px;
}

.logo-div {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.logo {
  height: 42px;
  width: auto;
  vertical-align: middle;
  border-radius: 8px;
}

.nav-container {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
}

.nav-links {
  display: inline-flex;
  align-items: center;
  gap: 16px;
}

.logo-stack {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.logo-text {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.logo-subtext {
  margin: 0;
  font-size: 12px;
  color: var(--text-secondary);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.menu-icon {
  border: 1px solid var(--border-color);
  background: var(--bg-glass);
  color: var(--text-primary);
}

.menu-icon .hamburger {
  font-size: 18px;
}

.dropdown-menu {
  position: absolute;
  top: 60px;
  right: 0;
  min-width: 200px;
  padding: 10px;
  border-radius: var(--radius-2xl);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-card);
  background: linear-gradient(180deg, #0c121e 0%, #0c121e 100%);
  color: var(--text-primary);
}

.dropdown-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 8px;
}

.dropdown-menu li {
  text-align: right;
}

.dropdown-menu a {
  display: block;
  padding: 8px 10px;
  border-radius: var(--radius-lg);
  color: var(--text-primary);
}

.dropdown-menu a:hover {
  background: rgba(255, 255, 255, 0.12);
}

@media (max-width: 780px) {
  .nav-links {
    display: none;
  }
}
</style>
